import { ThemeProvider } from "@mui/material";
import { heydoctorTheme } from "./theme/heydoctorTheme";
import { BrowserRouter, Route, Routes } from "react-router";
import LayoutPage from "./components/LayoutPage";
import HeyVetApp from "./heyvet/HeyVetApp";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { esES } from "@mui/x-date-pickers/locales";
import { es } from "date-fns/locale/es";
import { LayoutProvider } from "./context/LayoutContext";
import { RequestProvider } from "./context/RequestContext";
import { CatalogProvider } from "./context/CatalogContext";
import { QuestionProvider } from "./context/QuestionContext";

export default function App() {
    return (
        <ThemeProvider theme={heydoctorTheme}>
            <BrowserRouter>
                <LocalizationProvider dateAdapter={AdapterDateFns} localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText} adapterLocale={es}>
                    <LayoutProvider>
                        <RequestProvider>
                            <CatalogProvider>
                                <QuestionProvider>
                                    <Routes>
                                        <Route path="/e7b3a1f2-8c4d-4f5e-9a6b-2d1c3e4f5a6b/*" element={<HeyVetApp />} />
                                        <Route path="/*" element={<LayoutPage />} />
                                    </Routes>
                                </QuestionProvider>
                            </CatalogProvider>
                        </RequestProvider>
                    </LayoutProvider>
                </LocalizationProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}
